<template>
  <div>
    <div v-if="block">
      <div v-if="block.data.headtext" class="mb-2">
        <strong v-html="parsedHeadtext"></strong>
      </div>
      
      <div v-if="block.data.text" style="white-space: break-spaces" v-html="parsedText"></div>
    </div>
  </div>
</template>

<script>
import gameModule from '../modules/GameModule.js'
import moduleManager from '../modules/index.js'

export default {
  name: 'TextBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      gameState: null
    }
  },
  computed: {
    parsedHeadtext() {
      if (!this.block?.data?.headtext) return ''
      const text = this.showMultiLingualText(this.block.data.headtext)
      return this.parseVariables(text)
    },
    
    parsedText() {
      if (!this.block?.data?.text) return ''
      const text = this.showMultiLingualText(this.block.data.text)
      return this.parseVariables(text)
    },
    currentLanguage() {
      return this.$i18n?.locale || 'en'
    }
  },
  mounted() {
    // Get initial game state
    this.gameState = gameModule.getGameState()
    
    // Listen for game state changes
    moduleManager.addEventListener('game:state_updated', this.handleGameStateUpdate.bind(this))
  },
  beforeUnmount() {
    // Remove event listener
    moduleManager.removeEventListener('game:state_updated', this.handleGameStateUpdate.bind(this))
  },
  methods: {
    handleGameStateUpdate(newState) {
      this.gameState = newState
      // Force re-computation of parsed text
      this.$forceUpdate()
    },

    showMultiLingualText(text, altText = null, showFirstLanguage = false) {
      function isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value)
      }

      if (isObject(text)) {

        if (this.currentLanguage in text && text[this.currentLanguage]) {
          return String(text[this.currentLanguage])
        }

        // If the languageCode is not found, return the value associated with the first key
        if (altText) {
          return String(altText)
        }

        if (showFirstLanguage) {
          const firstKey = Object.keys(text)[0]
          if (text[firstKey]) {
            return String(text[firstKey])
          }
        }

        return ""
      }

      return (altText) ? String(altText) : (text ? String(text) : "")
    },

    parseVariables(text) {
      if (!text || typeof text !== 'string') {
        return text
      }

      // Parse variables in format {{ variable }} or {{variable}}
      return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, variableName) => {
        try {
          // Get variable value from GameModule
          const value = gameModule.getVariableValue(variableName)
          
          console.log(`TextBlock: Parsing variable ${variableName}, value:`, value)
          console.log(`TextBlock: GameModule state:`, gameModule.getGameState())
          
          if (value === null || value === undefined) {
            // Variable not found, return empty string instead of placeholder
            console.log(`TextBlock: Variable ${variableName} not found, returning empty string`)
            return ''
          }

          // Security: Escape HTML to prevent XSS
          const escapedValue = this.escapeHtml(String(value))
          console.log(`TextBlock: Variable ${variableName} escaped value:`, escapedValue)
          return escapedValue
        } catch (error) {
          console.warn(`Error parsing variable ${variableName}:`, error)
          return ''
        }
      })
    },

    escapeHtml(text) {
      if (!text || typeof text !== 'string') {
        return text
      }

      // Create a temporary div element to escape HTML
      const div = document.createElement('div')
      div.textContent = text
      return div.innerHTML
    }
  }
}
</script> 